import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="max-w-3xl" data-id="element-83" data-mp="3f3gft4kndsbs">
      <p className={`font-sans text-xs font-semibold uppercase tracking-[0.18em] ${isDark ? 'text-gold-400' : 'text-gold-600'}`} data-id="element-84" data-mp="3jznd68yz9vi4">
        {eyebrow}
      </p>
      <h2 className={`mt-3 font-display text-2xl font-bold leading-tight tracking-tightest sm:text-3xl ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-85" data-mp="gjzrtka4konw">
        {title}
      </h2>
      {description ? <p className={`mt-4 font-sans text-base leading-relaxed ${isDark ? 'text-platinum-300' : 'text-charcoal-600'}`} data-id="element-86" data-mp="6sc3vtcs1pr6">
          {description}
        </p> : null}
    </div>;
}